/** Month periods for the shell (PRD-018 §3.9): YYYY-MM strings, status against the firm's current open month. */
export type PeriodStatus = 'closed' | 'open' | 'upcoming'
export const PERIOD_RE = /^\d{4}-(?:0[1-9]|1[0-2])$/

export function shiftMonth(period: string, by: number): string {
  const [y, m] = period.split('-').map(Number) as [number, number]
  const d = new Date(Date.UTC(y, m - 1 + by, 1))
  return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, '0')}`
}
export function periodStatus(period: string, currentOpen: string): PeriodStatus {
  if (period === currentOpen)
    return 'open'
  return period < currentOpen ? 'closed' : 'upcoming'
}
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
export function periodLabel(period: string): string {
  const [y, m] = period.split('-').map(Number) as [number, number]
  return `${MONTHS[m - 1]} ${y}`
}
export function periodsBetween(from: string, to: string): string[] {
  const out: string[] = []
  for (let p = from; p <= to; p = shiftMonth(p, 1)) out.push(p)
  return out
}
/** "aug 2026" or "2026-08" typed in the palette → a period, or null. */
export function parsePeriodQuery(q: string): string | null {
  const s = q.trim().toLowerCase()
  if (PERIOD_RE.test(s))
    return s
  const m = /^([a-z]{3,9})\s+(\d{4})$/.exec(s)
  if (!m)
    return null
  const idx = MONTHS.findIndex(x => m[1]!.startsWith(x.toLowerCase()))
  return idx >= 0 ? `${m[2]}-${String(idx + 1).padStart(2, '0')}` : null
}
